module.exports = __webpack_public_path__ + "static/media/reviews.39f8b6ad.svg";